import { numberField } from '@/common/utils/form/fieldTypes';

export const evaluations_range_from = 'evaluations_range_from';
export const evaluations_range_to = 'evaluations_range_to';
export const evaluations_step = 'evaluations_step';

export type EvaluationsSettingsType = {
  [evaluations_range_from]: string;
  [evaluations_range_to]: string;
  [evaluations_step]: string;
};

const config = {
  [evaluations_range_from]: numberField(),
  [evaluations_range_to]: numberField(),
  [evaluations_step]: numberField()
};

export default config;
